import Collapsable from "components/Collapsable";
import Content from "components/Content";
import Label from "components/Label";
import Media from "components/Media";
import React, { FC, useState } from "react";
import { HiChevronDown as ChevronDown } from "react-icons/hi";

import { sections } from "./consants";
import styles from "./styles.module.scss";

const FAQ: FC = () => {
  const [selectedQuestion, setSelectedQuestion] = useState<null | string>(null);

  return (
    <Content contentClassName={styles.container}>
      <Label className={styles.title} variant="h2-centered" color="primary">
        FAQ
      </Label>
      <Label className={styles.subtitle} variant="s2-centered" color="primary">
        Have a question about our home management service? See answers to our
        most frequently asked questions below!
      </Label>
      {sections.map(({ section, FAQs }) => (
        <div className={styles.section}>
          <Media className={styles.sectionTitleWrapper} at={["desktop"]}>
            <Label className={styles.sectionTitle} variant="h4" color="primary">
              {section}
            </Label>
          </Media>
          <Media className={styles.sectionTitleWrapper} at={["responsive"]}>
            <Label className={styles.sectionTitle} variant="h3" color="primary">
              {section}
            </Label>
          </Media>
          <div className={styles.sectionFAQs}>
            {FAQs.map(({ question, answer }) => (
              <Collapsable
                open={selectedQuestion === question}
                onSelect={(id: string) => {
                  if (id === selectedQuestion) setSelectedQuestion(null);
                  else setSelectedQuestion(id);
                }}
                id={question}
                className={styles.collapsable}
                header={
                  <div className={styles.question}>
                    <Label variant="s2" color="primary">
                      {question}
                    </Label>
                    <ChevronDown
                      className={`${styles.chevron} ${
                        selectedQuestion === question && styles.chevronUp
                      }`}
                    />
                  </div>
                }
              >
                <Label useMarkdown color="primary">
                  {answer}
                </Label>
              </Collapsable>
            ))}
          </div>
        </div>
      ))}
    </Content>
  );
};
export default FAQ;
